<template>
<div class="d-none p-2 bg-warning border-bottom text-center">
    本站建议最低逻辑分辨率宽度720px
</div>
</template>

<style scoped>
@media (width <= 720px) {
    div {
        display: block !important;
    }
}
</style>
